import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbThemeService,
} from "@nebular/theme";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { DialogGalleryComponent } from "../dialog-gallery/dialog-gallery.component";

@Component({
  selector: "ngx-view-gallery",
  styleUrls: ["./view-gallery.component.scss"],
  templateUrl: "./view-gallery.component.html",
})
export class ViewGalleryComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() imagesUrl: string[] = [];
  @Input() imageObject = [];
  @Input() mode: string; //view / upload
  @Output() onImageClick: EventEmitter<any> = new EventEmitter();

  isMobile = false;
  sWidth = "25%";
  sHeight = "200px";

  constructor(
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService,
    private dialogService: NbDialogService
  ) {
    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
        if (this.isMobile) {
          this.sWidth = "50%";
          this.sHeight = "100px";
        }
      });
  }

  ngOnInit(): void {
    if (!this.imagesUrl || this.imagesUrl.length === 0) {
      this.imagesUrl = [];
      this.imagesUrl.push(
        "https://kasoft-learning.s3.ap-southeast-1.amazonaws.com/Courses/cover-default.png"
      );
    }

    if (!this.imageObject || this.imageObject.length === 0) {
      this.imagesUrl.forEach((item) => {
        this.imageObject.push({
          image: item,
          thumbImage: item.replace(
            "https://ik.imagekit.io/kasoft/",
            "https://ik.imagekit.io/kasoft/tr:n-media_library_thumbnail/"
          ),
          title: "",
        });
      });
    }

    if (!this.mode) this.mode = "view"; //upload
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  imageClick(value) {
    if (this.mode == "upload") {
      this.onImageClick.emit(this.imageObject[value].image);
    } else {
      this.dialogService.open(DialogGalleryComponent, {
        context: {
          imageObject: this.imageObject,
          imgIndex: value,
        },
      });
    }
  }
}
